<template>
  <v-sheet color="white" class="px-4 pb-4" rounded>
    <!-- <div class="title text-uppercase">Upload Attachment</div> -->
    <v-form v-model="valid" ref="formUpload">
      <v-file-input
        :multiple="isMultipleFile"
        :dense="dense"
        :placeholder="placeholderComputed"
        v-model="files"
        @change="onSelectFiles"
        :loading="progressUpload"
        :clearable="false"
        show-size
        :accept="acceptComputed"
        :prepend-icon="null"
        :rules="[ruleMax]"
        outlined
      ></v-file-input>
    </v-form>
    <v-list v-show="fileList.length > 0" dense tile style="border:1px solid #e3e3e3;">
      <v-list-item
        v-for="(item,idx) of fileList"
        :key="`file_${idx}`"
        :class="{ 'has-border-top': idx > 0}"
      >
        <v-list-item-icon class="mr-2 align-self-center">
          <v-icon class="fa-fw" small>far fa-file</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <div>{{ item.file.name }}</div>
          <v-progress-linear
            class="my-1"
            :color="item.failed ? 'error' : 'teal'"
            :buffer-value="computedBuffer(item)"
            :value="item.percentage"
            :stream="item.progress"
          ></v-progress-linear>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="d-flex mt-4 fade-transition" v-if="fileList.length > 0">
      <!-- <v-btn depressed color="primary" @click="start" :disabled="progressUpload">
        <v-icon left>far fa-upload</v-icon>Start Upload
      </v-btn>-->
      <!-- <v-spacer></v-spacer> -->
      <v-btn text @click="clear">
        <v-icon left>far fa-undo</v-icon>Cancel
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: ["multiple", "service", "maxSize", "placeholder", "dense", "accept"],
  data: () => ({
    files: [],
    fileList: [],
    progressUpload: false,
    valid: true,
  }),
  computed: {
    ruleMax() {
      return (val) => this.ruleMaxFunc(val);
    },
    isMultipleFile() {
      if (this.multiple != null && this.multiple === true) {
        return true;
      }
      return false;
    },
    denseComputed() {
      if (this.dense != null && this.dense === true) {
        return true;
      }
      return false;
    },
    maxSizeComputed() {
      if (this.maxSize != null && this.maxSize != 0) {
        return this.maxSize;
      }
      return 4; // 4 MB
    },
    placeholderComputed() {
      if (this.placeholder != null && this.placeholder != "") {
        return this.placeholder;
      }
      return "Choose file to upload";
    },
    acceptComputed() {
      if (this.accept != null && this.accept != "") {
        return this.accept;
      }
      return "*";
    },
  },
  methods: {
    ruleMaxFunc(files) {
      let valid = true;
      const max = this.maxSizeComputed * 1000 * 1000;
      for (let file of files) {
        if (file.size > max) {
          valid = false;
          break;
        }
      }

      if (valid) {
        return true;
      } else {
        return `File size should be less than ${this.maxSizeComputed} MB!`;
      }
    },
    computedBuffer(item) {
      if (item.failed) {
        return 100;
      } else {
        if (item.progress) {
          return 0;
        } else {
          return 100;
        }
      }
    },
    onSelectFiles(files) {
      if (files != null && files.length > 0) {
        this.fileList = files.map((file) => {
          // console.log(file.size);
          return {
            file: file,
            progress: false,
            done: false,
            percentage: 0,
            failed: false,
          };
        });
      } else {
        this.clear();
        this.$emit("success");
      }
    },
    start() {
      this.progressUpload = true;
      this.uploadFiles();
    },
    uploadFiles() {
      let file = this.fileList.find((x) => x.done == false);
      if (file != undefined) {
        file.progress = true;
        this.createUpload(file)
          .then((resp) => {
            file.done = true;
            this.$nextTick(() => {
              // recursive
              this.uploadFiles();
            });
          })
          .catch((err) => {
            file.done = false;
            file.failed = true;
            this.progressUpload = false;
          })
          .finally(() => {
            file.progress = false;
          });
      } else {
        this.clear();
        this.$emit("success");
      }
    },
    createUpload(obj) {
      let fd = new FormData();
      fd.append("taskId", this.taskId.toString());
      fd.append(obj.file.name, obj.file);
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          this.updateProgress(progressEvent, obj);
        },
      };
      return this.$http.post(`${this.service}`, fd, config);
    },
    updateProgress(progressEvent, obj) {
      let tmp = Math.round(progressEvent.loaded / progressEvent.total);
      obj.percentage = tmp * 100;
    },
    clear() {
      this.files = [];
      this.fileList = [];
      this.progressUpload = false;
      this.$refs.formUpload.resetValidation();
    },
  },
};
</script>